import React, { useState, useEffect } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { getCurrentUser, fetchUserAttributes } from '@aws-amplify/auth';

const MSPProtectedRoute = ({ isAuthPage, mspConfig }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [userMspID, setUserMspID] = useState(null);

  useEffect(() => {
    checkAuthState();
  }, []);

  const checkAuthState = async () => {
    try {
      await getCurrentUser();
      const attributes = await fetchUserAttributes();
      const userType = attributes['custom:userType'];
      const mspID = attributes['custom:mspID'];
      
      // Verify user is MSP user and belongs to this MSP
      if (userType === 'msp' && mspID === mspConfig.mspID) {
        setIsAuthenticated(true);
        setUserMspID(mspID);
      } else {
        setIsAuthenticated(false);
      }
    } catch (error) {
      setIsAuthenticated(false);
    }
  };

  if (isAuthenticated === null) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  // Auth pages (login) - redirect if already authenticated
  if (isAuthPage) {
    return isAuthenticated ? <Navigate to="/dashboard" /> : <Outlet />;
  }

  // Protected pages - redirect to login if not authenticated
  return isAuthenticated ? <Outlet /> : <Navigate to="/login" />;
};

export default MSPProtectedRoute;